import { render, staticRenderFns } from "./BatteryCellInfo.vue?vue&type=template&id=a4d2248c&"
import script from "./BatteryCellInfo.vue?vue&type=script&lang=js&"
export * from "./BatteryCellInfo.vue?vue&type=script&lang=js&"
import style0 from "./BatteryCellInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports